import styled from 'styled-components';

export const Content = styled.main`
  padding: 8px 30px 70px;
  @media (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
  }
  min-height: calc(100vh - 120px);
  align-items: center;
  justify-content: center;
  display: flex;

  .content {
    width: 360px;
    max-width: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
  button {
    width: 155px;
    margin: 20px 0 0;
  }
`;
